// Version : 0.0.3
// Author : VIGNESH
// LastEdit : VISHAL BHARATHI
// Last ADD : ENACH REPORT EXPORT SAGA REMOVED
// MODIFIED DATE: 19-09-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';

import ENACHReportActionTypes from './enachReport.types';

import { fetchENACHReport } from './enachReport.service';

import {
	// FETCH ENACH REPORT
	fetchENACHReportSuccess,
	fetchENACHReportFailure,
	fetchENACHReportResponseChanged,
} from './enachReport.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET ENACH REPORT  ******************** */
export function* fetchENACHReportDetails({ payload }: any) {
	try {
		const key = 'FetchEnachReportListKey';
		const { companyID, databaseName, demandDate, loanType, limit } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			DemandDate: demandDate,
			LoanType: loanType,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchENACHReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchENACHReportFailure(responseData.data));
		} else {
			yield put(fetchENACHReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchENACHReportFailure(error));
	}
}

export function* resetFetchEnachReportResponse() {
	yield put(fetchENACHReportResponseChanged());
}

export function* onFetchENACHReport() {
	yield takeLatest(ENACHReportActionTypes.FETCH_ENACH_REPORT_START, fetchENACHReportDetails);
}

export function* onFetchENACHReportResponseReset() {
	yield takeLatest(
		ENACHReportActionTypes.FETCH_ENACH_REPORT_RESPONSE_RESET,
		resetFetchEnachReportResponse,
	);
}
/** *********************  END OF GET ENACH REPORT  ******************** */

export function* enachReportSaga() {
	yield all([call(onFetchENACHReport), call(onFetchENACHReportResponseReset)]);
}
